const DashboardWrapper = ({
  children,
  title,
}: {
  children: React.ReactNode;
  title?: string;
}) => {
  return (
    <div className="p-[2rem] bg-white rounded-[0.5rem]" style={{ boxShadow: "0 2px 4px rgba(0, 0, 0, 0.1)" }}>
      {title && (
        <span className="text-[2.2rem] font-medium">
          {title}
        </span>
      )}
      <div>{children}</div>
    </div>
  );
};

export default DashboardWrapper;
